import React from 'react';
import PropTypes from 'prop-types';

import { DropdownMenuItem } from '../../../../../components';

const RoleItem = ({ current, name, onClick }) => {
  const handleMouseDown = (evt) => {
    evt.preventDefault();
    if (onClick) {
      onClick(evt);
    }
  };

  return (
    <DropdownMenuItem disabled={current} shouldCloseMenu={false} onMouseDown={handleMouseDown}>
      {name}
    </DropdownMenuItem>
  );
};

RoleItem.propTypes = {
  current: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export { RoleItem };
